module.exports = __webpack_public_path__ + "cdc5af2b90406cfc7a2a8d562e6ce39c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/red-hot-air-balloon-empty.png
// module id = 338
// module chunks = 0